import React from "react";
import { Card, Tabs } from "antd";
import CashReport from "./reportPage/CashReport";
import CardReport from "./reportPage/CardReport";
import BankReport from "./reportPage/BankReport";
import OnlineReport from "./reportPage/OnlineReport";
import OtherReport from "./reportPage/OtherReport";

const PaymodeViseReport = () => {


  const tabItemsData = [
    {
      key: "1",
      label: "Cash Report",
      content: <CashReport />
    },
    {
      key: "2",
      label: "Card Payment Report",
      content: <CardReport />
    },
    {
      key: "3",
      label: "Bank Transfer Report",
      content: <BankReport />
    },
    {
      key: "4",
      label: "Online Payment Report",
      content: <OnlineReport />
    },
    {
      key: "5",
      label: "Other Payment Report",
      content: <OtherReport />
    }
  ];



  const tabItems = tabItemsData.map(item => ({
    key: item.key,
    label: item.label,
    children: item.content
  }));

  return (

    <Card
      title="Pay Mode Vise Report"
      size="large"
    >

      <Tabs
        size="large"
        tabPosition="left"
        items={tabItems}
        destroyInactiveTabPane={false}
      />


    </Card>
  );
};

export default PaymodeViseReport;
